import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "impersonation-banner",
  role: "alert",
  "aria-live": "assertive"
}
const _hoisted_2 = { class: "impersonation-banner__inner" }
const _hoisted_3 = { class: "impersonation-banner__badge" }
const _hoisted_4 = { class: "impersonation-banner__text" }
const _hoisted_5 = {
  key: 0,
  class: "impersonation-banner__email"
}

import { computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Icon } from "@/components/ui";
import { LOGIN_ROUTE } from "@/router/routes";
import { CLEAR_IMPERSONATION, SET_SESSION_TOKEN, SET_ACCOUNT } from "@/store/mutation-types";
import { LOCAL_STORAGE_KEY, IMPERSONATION_SESSION_KEY } from "@/utils/const";


export default /*@__PURE__*/_defineComponent({
  __name: 'ImpersonationBanner',
  setup(__props) {

const store = useStore();
const router = useRouter();

const isImpersonating = computed(() => store.getters.isImpersonating);
const info = computed(() => store.getters.impersonationInfo);

const handleExit = () => {
  store.commit(CLEAR_IMPERSONATION);
  store.commit(SET_SESSION_TOKEN, null);
  store.commit(SET_ACCOUNT, { data: null, isLoading: false });
  sessionStorage.removeItem(LOCAL_STORAGE_KEY);
  sessionStorage.removeItem(IMPERSONATION_SESSION_KEY);
  try {
    window.close();
  } catch {}
  router.push({ name: LOGIN_ROUTE });
};

return (_ctx: any,_cache: any) => {
  return (isImpersonating.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Icon), {
              icon: "mdi:shield-account",
              width: "14",
              height: "14",
              "aria-hidden": "true"
            }),
            _cache[0] || (_cache[0] = _createTextVNode(" ADMIN VIEW ", -1))
          ]),
          _createElementVNode("span", _hoisted_4, [
            _cache[1] || (_cache[1] = _createTextVNode(" Viewing account of ", -1)),
            _createElementVNode("strong", null, _toDisplayString(info.value.userName || info.value.userEmail || "Unknown User"), 1),
            (info.value.userName && info.value.userEmail)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, " · " + _toDisplayString(info.value.userEmail), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            class: "impersonation-banner__exit",
            onClick: handleExit
          }, [
            _createVNode(_unref(Icon), {
              icon: "mdi:logout-variant",
              width: "13",
              height: "13",
              "aria-hidden": "true"
            }),
            _cache[2] || (_cache[2] = _createTextVNode(" Exit Session ", -1))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})